import { initializeBulkAcceptanceState } from '../state/app.state';
import { createReducer, on, Action } from '@ngrx/store';
import * as fromBulkAcceptanceAction from '../action/bulk-acceptance.action';
import { IBulkAcceptanceData } from '@app/@shared/Models/bulk-acceptance.model';

export const initialOrderState: IBulkAcceptanceData = initializeBulkAcceptanceState();

const reducer = createReducer(
    initialOrderState,
    on(fromBulkAcceptanceAction.GetBulkAcceptanceSuccess, (state: IBulkAcceptanceData, { payload }) => {
        return { ...state, BulkAcceptanceResponse: payload };
    }),
    on(fromBulkAcceptanceAction.GetBulkAcceptanceError, (state, { payload }) => {
        return { ...state, error: payload };
    })
);

export function BulkAcceptanceReducer(state: IBulkAcceptanceData | undefined, action: Action) {
    return reducer(state, action);
}